import { render, staticRenderFns } from "./gauge.vue?vue&type=template&id=b476594a&scoped=true"
import script from "./gauge.vue?vue&type=script&lang=js"
export * from "./gauge.vue?vue&type=script&lang=js"
import style0 from "./gauge.vue?vue&type=style&index=0&id=b476594a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b476594a",
  null
  
)

export default component.exports